<template>
  <div>
    <v-row class="grey lighten-3" style="height: 1080px">
      <v-col
        md="4"
        class="hidden-sm-and-down side-image"
        style="background-color: #ffffff; font-size: 32px"
      >
        <!-- <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a> -->
      </v-col>
      <v-col
        md="8"
        sm="12"
        style="background-color: #ffffff; position: relative"
        class=""
      >
        <v-row class="inquiry-form" style="">
          <v-card-title class="font-weight-black mt-4"
            >お問い合わせ</v-card-title
          >
          <v-card-text class="pa-5 pt-0">
            <ValidationObserver ref="observer" v-slot="{ invalid }">
              <v-row>
                <v-col cols="12">
                  <ValidationProvider
                    name="名前"
                    rules="required|max:30"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="名前(必須)"
                      v-model="user.name"
                      :error-messages="errors"
                      class="mt-0"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <ValidationProvider
                    name="企業名"
                    rules="max:50"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="企業名"
                      v-model="inquiry.company"
                      :error-messages="errors"
                      class="mt-0"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <ValidationProvider
                    name="メールアドレス"
                    rules="required|email|max:255"
                    v-slot="{ errors }"
                  >
                    <v-text-field
                      label="メールアドレス(必須:ここに入力したアドレスに問い合わせの回答を送信します)"
                      type="email"
                      v-model="user.email"
                      :error-messages="errors"
                      class="mt-0"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <ValidationProvider name="お問い合わせ種別" rules="required">
                    <p class="mb-0">お問い合わせの種類(必須)</p>
                    <v-radio-group
                      class="mt-0"
                      v-model="inquiry.inquiry_type"
                      mandatory
                      row
                    >
                      <v-radio label="機能について" value="1"></v-radio>
                      <!-- <v-radio
                      label="不具合報告"
                      value="2"
                    ></v-radio> -->
                      <v-radio label="導入について" value="3"></v-radio>
                      <v-radio label="料金について" value="4"></v-radio>
                      <v-radio label="その他" value="99"></v-radio>
                    </v-radio-group>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <ValidationProvider
                    name="お問い合わせ内容"
                    rules="required|max:20000"
                    v-slot="{ errors }"
                  >
                    <v-textarea
                      label="お問い合わせ内容(必須)"
                      v-model="inquiry.inquiry_contents"
                      :error-messages="errors"
                    ></v-textarea>
                  </ValidationProvider>
                </v-col>
                <!-- <v-col cols=12>
                <ValidationProvider name="お問い合わせ画像" rules="" v-slot="{ errors }">
                  <p class="mb-0">お問い合わせ画像</p>
                  <p class="text-body-2 mb-0">※不具合画面のスクリーンショットなど画像があれば添付してください</p>
                  <p class="text-body-2 mb-0">※JPG、JPEG、PNG形式の画像をアップロードしてください。最大ファイルサイズ: 20MB</p>
                  <div>
                    <UploadImages 
                      class="" @changed="handleImages" :error-messages="errors" fileError ="JPG、JPEG、PNG形式の画像をアップロードしてください"
                      :max="1" maxError="画像は１枚のみ選択してください" uploadMsg ="ここをクリックするか、ここに画像をドロップしてください"
                    />
                  </div>
                </ValidationProvider>
              </v-col> -->
                <v-col cols="12">
                  <ValidationProvider name="お問い合わせ種別" rules="required">
                    <v-checkbox v-model="selected" value="John">
                      <template v-slot:label>
                        <a
                          @click.stop
                          rel="noopener noreferrer"
                          href="https://respawn.jp/privacy-policy/"
                          target="_blank"
                          >個人情報保護方針
                        </a>
                        <span>
                          に同意いただけましたら「送信」ボタンを押してください。
                        </span>
                      </template>
                    </v-checkbox>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn
                    color="primary"
                    class="button-shadow ma-4"
                    width="50%"
                    :disabled="invalid"
                    @click="openModal()"
                    :loading="loading"
                    >確認</v-btn
                  >
                </v-col>
              </v-row>
            </ValidationObserver>
          </v-card-text>
        </v-row>
      </v-col>
    </v-row>
    <!-- <InquiryConfirmModal :inquiry="inquiry" :user="user" :imageUrl="imageUrl"/> -->
    <InquiryConfirmModal :inquiry="inquiry" :user="user" />
  </div>
</template>
<style scoped>
/* コンポーネントのvue-upload-dropimagesにスタイルを当てている */
>>> .error {
  color: black;
  background-color: transparent;
}
</style>
<script>
import InquiryConfirmModal from "../organisms/InquiryConfirmModal.vue";
import UploadImages from "vue-upload-drop-images";
export default {
  name: "InquiryForm",
  components: {
    InquiryConfirmModal,
    UploadImages,
  },
  created() {
    if (this.isAuth) {
      return this.getUserInfo();
    } else {
      return;
    }
  },
  data() {
    return {
      inquiry: {
        company: "",
        inquiry_type: "",
        inquiry_contents: "",
      },
      user: {
        name: "",
        email: "",
        user_id: "",
      },
      inquiry_image: "",
      imageUrl: "",
      loading: false,
      height: 500,
      isFinished: false,
    };
  },
  computed: {
    isOpenModal() {
      return this.$store.getters["inquiryModal/isOpen"];
    },
    getUserCode() {
      return this.$store.getters["auth/isUserCode"];
    },
    isAuth() {
      return this.$store.getters["auth/isAuth"];
    },
  },
  methods: {
    getUserInfo() {
      this.$store.dispatch("userinfo/get", this.getUserCode).then(() => {
        this.user = this.$store.getters["userinfo/getUser"];
      });
    },
    openModal() {
      const data = {
        isOpen: true,
      };
      this.$store
        .dispatch("inquiryModal/actionModalOpen", data)
        .then(() => {
          this.loading = true;
          this.create();
        })
        .catch(() => {});
    },
    // handleImages(files) {
    //   const file = files[0]
    //   if (!file) {
    //     return;
    //   }
    //   this.inquiry_image = file;
    //   this.imageUrl = URL.createObjectURL(file)
    // },
    create() {
      let inquiryData = new FormData();
      for (const key in this.user) {
        inquiryData.append(key, this.user[key]);
      }
      for (const key in this.inquiry) {
        inquiryData.append(key, this.inquiry[key]);
      }
      inquiryData.append("inquiry_image", this.inquiry_image);
      this.$axios
        .post(process.env.VUE_APP_API_BASE_URL + "/inquiry", inquiryData, {
          headers: { "content-type": "multipart/form-data" },
        })
        .then(() => {
          setTimeout(
            function () {
              this.$router.push("/inquiry/finish");
            }.bind(this),
            2000
          );
        });
    },
  },
};
</script>